import React from 'react';
import Formsy from 'formsy-react';
import Input from '../../form/FormsyInput';
import Radio from '../../form/Radio';
import Checkbox from '../../form/FormsyCheckbox';
import withOnboarding from '../withOnboarding';
import { menuAPI } from '../../../InterfaceAPI/menuAPI';

class ClientPreferences extends React.Component {
  defaultState = {
    portion_size: '',
    dietary_preference_tags: [],
    allergen_tags: [],
    other_allergens: '',
    special_instructions: '',
    redirect: false
  };

  state = {
    availableAllergens: [],
    availableDiets: [],
    ...this.defaultState
  };

  portionOptions = [
    { label: 'Small 1-2 Mouths', value: 'small' },
    { label: 'Medium 3-4 Mouths', value: 'medium' },
    { label: 'Large 5-6 Mouths', value: 'large' }
  ];

  render() {
    // render form
    return (
      <div className="on-boarding__step on-boarding_step--client">
        <div className="on-boarding__wrap on-boarding__wrap--client-preferences">
          <h1 className="on-boarding__h1">
            What are your culinary preferences?
          </h1>
          <Formsy
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
          >
            <div className="on-boarding__form-group on-boarding__form-group--no-pad">
              <h3 className="on-boarding__h3">Portion Size</h3>
              <p className="on-boarding__p on-boarding__hang-left">
                Our portions are based on household size, but you should adjust
                your selection based on household appetities (big / small
                eaters) and frequency (how many days you'll rely on the
                service). Portion size only effects grocery costs and can be
                changed week to week.
              </p>
              <Radio
                className="radio--large radio--inline-full-mobile radio--blue radio--blue-green"
                name="portion_size"
                options={this.portionOptions}
                value={this.state.portion_size}
                onChange={this.handleChange}
                required
              />
            </div>

            <div className="on-boarding__form-group">
              <h3 className="on-boarding__h3">Diet</h3>
              <p className="on-boarding__p on-boarding__hang-left">
                Please let us know your general dietary restrictions so we can
                modify your future dish selections.
              </p>
              <div className="checkbox__row on-boarding__button-wrap">
                {this.renderDiets()}
              </div>
            </div>

            <div className="on-boarding__form-group">
              <h3 className="on-boarding__h3">Allergens</h3>
              <div className="checkbox__row on-boarding__button-wrap">
                {this.renderAllergens()}
              </div>
              <div className="on-boarding__hang-left">
                <Input
                  name="other_allergens"
                  value={this.state.other_allergens}
                  onChange={this.handleChange}
                  placeholder="Other Food Allergens"
                />
              </div>
            </div>

            <div className="on-boarding__form-group">
              <h3 className="on-boarding__h3">Special Instructions</h3>
              <div className="on-boarding__hang-left">
                <p className="on-boarding__p ">
                  Enter any other preferences about your menu, groceries, chef,
                  or service here.
                </p>
                <Input
                  name="special_instructions"
                  value={this.state.special_instructions}
                  onChange={this.handleChange}
                  placeholder="I would like to..."
                />
              </div>
            </div>

            <Input
              type="hidden"
              name="all_forms_valid"
              value={this.props.actions.isValid('submit')}
              validations="isTrue"
            />
            <input
              ref={this.props.actions.assignTrigger}
              type="submit"
              hidden
            />
          </Formsy>
        </div>
      </div>
    );
  }

  renderAllergens() {
    return this.state.availableAllergens.map(item => (
      <div
        key={item.id}
        className="checkbox__item checkbox__item--half-to-quarter"
      >
        <Checkbox
          name={item.tag}
          className="checkbox--large checkbox--large-blue-white checkbox--flex"
          placeholder={item.tag}
          checked={this.isChecked(this.state.allergen_tags, item)}
          onChange={e => this.toggleAllergens(item)}
        />
      </div>
    ));
  }

  isChecked = (arr, value) => {
    return arr.findIndex(val => val.id === value.id) >= 0;
  };

  toggleAllergens = value => {
    if (this.isChecked(this.state.allergen_tags, value)) {
      // delete
      const index = this.state.allergen_tags.findIndex(
        val => val.id === value.id
      );
      const allergen_tags = [
        ...this.state.allergen_tags.slice(0, index),
        ...this.state.allergen_tags.slice(
          index + 1,
          this.state.allergen_tags.length
        )
      ];
      this.setState({ allergen_tags });
    } else {
      // add
      const allergen_tags = [...this.state.allergen_tags, value];
      this.setState({ allergen_tags });
    }
  };

  renderDiets() {
    return this.state.availableDiets.map(item => (
      <div
        key={item.id}
        className="checkbox__item checkbox__item--half-to-quarter"
      >
        <Checkbox
          name={item.tag}
          className="checkbox--large checkbox--large-blue-white checkbox--flex"
          placeholder={item.tag}
          checked={this.isChecked(this.state.dietary_preference_tags, item)}
          onChange={e => this.toggleDiets(item)}
        />
      </div>
    ));
  }

  toggleDiets = value => {
    if (this.isChecked(this.state.dietary_preference_tags, value)) {
      // delete
      const index = this.state.dietary_preference_tags.findIndex(
        val => val.id === value.id
      );
      const dietary_preference_tags = [
        ...this.state.dietary_preference_tags.slice(0, index),
        ...this.state.dietary_preference_tags.slice(
          index + 1,
          this.state.dietary_preference_tags.length
        )
      ];
      this.setState({ dietary_preference_tags });
    } else {
      // add
      const dietary_preference_tags = [
        ...this.state.dietary_preference_tags,
        value
      ];
      this.setState({ dietary_preference_tags });
    }
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ChefOnboarding component
  handleSubmit = (formData, data, errors) => {
    const {
      portion_size,
      dietary_preference_tags,
      allergen_tags,
      other_allergens,
      special_instructions
    } = this.state;
    // update client
    const updatedClient = {
      portion_size,
      dietary_preference_tags,
      allergen_tags,
      other_allergens,
      special_instructions
    };
    this.props.updateClient(updatedClient);
    this.props.actions.markComplete(this.props.step);
  };

  reset = () => this.props.updateClient({ ...this.defaultState });

  initState(prevProps = {}) {
    const state = {};

    // init client state from props
    if (this.props.client !== prevProps.client) {
      const {
        portion_size,
        dietary_preference_tags,
        allergen_tags,
        other_allergens,
        special_instructions
      } = this.props.client;
      state.portion_size = portion_size;
      state.dietary_preference_tags = dietary_preference_tags;
      state.allergen_tags = allergen_tags;
      state.other_allergens = other_allergens;
      state.special_instructions = special_instructions;
    }

    if (
      state.portion_size ||
      state.dietary_preference_tags ||
      state.allergen_tags ||
      state.other_allergens ||
      state.special_instructions
    )
      this.setState(state);
  }

  componentWillMount() {
    // handle resets here
    const reset = this.props.resets.includes(this.props.step);
    if (reset) this.reset();
    else this.initState();
  }

  componentDidMount() {
    menuAPI
      .getAllergens()
      .then(({ allergen_tags: availableAllergens }) =>
        this.setState({ availableAllergens })
      )
      .catch(error => console.log(error));

    menuAPI
      .getDiets()
      .then(({ dietary_preference_tags: availableDiets }) =>
        this.setState({ availableDiets })
      )
      .catch(result => console.log(result));
  }

  componentDidUpdate(prevProps, nextState) {
    this.initState(prevProps);
  }
}

export default withOnboarding(ClientPreferences);



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientPreferences.js